/**
 * Created by swchen on 2017/6/7.
 */


import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("api/nursecarecore/department");

function getRootNurseUnitWithoutExceptionHandleAsync(param) {
    return remoteCall._invoke("getRootNurseUnit", param);
}

function queryByTextAsync(param) {
    return remoteCall.invoke("queryByText", param);
}

function updateRoleUserUnitAsync(param) {
    return remoteCall.invoke("updateRoleUserUnit", param);
}

// 更新科室类型
function updateUnitTypesAsync(param) {
    return remoteCall.invoke("updateUnitTypes", param);
}

const findTreeAsync = (params) => {
    return remoteCall.invoke("findTree", params);
}

const findListAsync = (params) => {
    return remoteCall.invoke("findList", params);
}

const sortUnitsAsync = (params) => {
    return remoteCall.invoke("sortUnits", params);
}

const addUnitAsync = (params) => {
    return remoteCall.invoke("addUnit", params);
}

const importUnitsAsync = (params) => {
    return remoteCall.invoke("importUnits", params);
}

const addUnitTreeAsync = (params) => {
    return remoteCall.invoke("addUnitTree", params);
}

const updateUnitAsync = (params) => {
    return remoteCall.invoke("updateUnit", params);
}

const updateParentAsync = (params) => {
    return remoteCall.invoke("updateParent", params);
}

const deleteUnitsAsync = (params) => {
    return remoteCall.invoke("deleteUnits", params);
}


export default {

    getRootNurseUnitWithoutExceptionHandleAsync,
    queryByTextAsync,

    updateRoleUserUnitAsync,

    updateUnitTypesAsync,

    findTreeAsync,
    findListAsync,
    sortUnitsAsync,
    addUnitAsync,
    importUnitsAsync,
    addUnitTreeAsync,
    updateUnitAsync,
    updateParentAsync,
    deleteUnitsAsync,
}
